import { Panel } from "../layout/Panel.tsx";
import { MetricCard } from "../viz/MetricCard.tsx";
import { metrics } from "../../stores/metrics.ts";

export function VideoPanel() {
  const get = (m: string) => metrics.latest[`mux:${m}`]?.value;
  return (
    <Panel title="Video · Mux" href="https://dashboard.mux.com" span="col-span-4">
      <div class="grid grid-cols-2 gap-3">
        <MetricCard label="Views" value={get("views")} digits={0} />
        <MetricCard label="Playback Failure" value={get("playback_failure_pct")} unit="%" digits={2} />
        <MetricCard label="Startup Time" value={get("startup_ms")} unit="ms" digits={0} />
        <MetricCard label="Rebuffer %" value={get("rebuffer_pct")} unit="%" digits={2} />
      </div>
    </Panel>
  );
}
